import { render } from "./ShapExplanation.vue?vue&type=template&id=4ebd4684&scoped=true"
import script from "./ShapExplanation.vue?vue&type=script&lang=js"
export * from "./ShapExplanation.vue?vue&type=script&lang=js"

import "./ShapExplanation.vue?vue&type=style&index=0&id=4ebd4684&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebd4684"]])

export default __exports__